import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { trackCalendlyConversion } from './GoogleTagLoader';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white/95 backdrop-blur-sm shadow-sm fixed top-0 left-0 right-0 z-50 transition-all duration-300" data-id="element-198" data-mp="2il7mlzaeo17i">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-199" data-mp="2nm54sbvf0v90">
        <div className="flex justify-between h-20 items-center" data-id="element-200" data-mp="2rmp2bgjwi0vo">
          <div className="flex-shrink-0 flex items-center" data-id="element-201" data-mp="2rkb797p80oo4">
            <a href="#" className="text-2xl font-bold text-indigo-600" data-id="element-202" data-mp="2wjxkhh51u4wx">
              Turnout
            </a>
          </div>

          {/* Desktop menu */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-203" data-mp="36as9uudldkml">
            <a href="#features" className="text-gray-600 hover:text-indigo-600 px-3 py-2 text-sm font-medium transition-colors" data-id="element-204" data-mp="36d4nivcbh8tu">
              Features
            </a>
            <a href="#case-studies" className="text-gray-600 hover:text-indigo-600 px-3 py-2 text-sm font-medium transition-colors" data-id="element-205" data-mp="3f9dnqc84cbh1">
              Case Studies
            </a>
            <a href="#about" className="text-gray-600 hover:text-indigo-600 px-3 py-2 text-sm font-medium transition-colors" data-id="element-206" data-mp="2mmok4b97qb0w">
              About
            </a>
            <a href="#testimonials" className="text-gray-600 hover:text-indigo-600 px-3 py-2 text-sm font-medium transition-colors" data-id="element-207" data-mp="3fb2nz7mzg1kd">
              Testimonials
            </a>
            <a href="https://calendly.com/dan-at-turnout/turnout-general-30-min-call" target="_blank" rel="noopener noreferrer" onClick={trackCalendlyConversion} className="ml-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 transition-colors shadow-sm" data-id="element-208" data-mp="35kr6sjeafvvj">
              Book a 30-Min Intake
            </a>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-209" data-mp="1wc4r8lxb91tz">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-600 hover:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500" data-id="element-210" data-mp="1hnrpf8bjkork">
              {isMenuOpen ? <X size={24} data-id="element-211" data-mp="18pg0daqbpz18" /> : <Menu size={24} data-id="element-212" data-mp="1cof8133fw9wd" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-white shadow-lg border-t border-gray-100" data-id="element-213" data-mp="yqgrps5k63e8">
          <div className="px-4 pt-4 pb-6 space-y-2" data-id="element-214" data-mp="13p1sbsoq2p37">
            <a href="#features" className="block px-3 py-3 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50" onClick={() => setIsMenuOpen(false)} data-id="element-215" data-mp="13ptnx3ibkmth">
              Features
            </a>
            <a href="#case-studies" className="block px-3 py-3 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50" onClick={() => setIsMenuOpen(false)} data-id="element-216" data-mp="mey07526i8xg">
              Case Studies
            </a>
            <a href="#about" className="block px-3 py-3 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50" onClick={() => setIsMenuOpen(false)} data-id="element-217" data-mp="rc6j57v5igzr">
              About
            </a>
            <a href="#testimonials" className="block px-3 py-3 rounded-md text-base font-medium text-gray-700 hover:text-indigo-600 hover:bg-gray-50" onClick={() => setIsMenuOpen(false)} data-id="element-218" data-mp="1f3lkoyf3su9y">
              Testimonials
            </a>
            <div className="pt-4 mt-4 border-t border-gray-100" data-id="element-219" data-mp="3bw5axrq1t549">
              <a href="https://calendly.com/dan-at-turnout/turnout-general-30-min-call" target="_blank" rel="noopener noreferrer" onClick={() => {
            trackCalendlyConversion();
            setIsMenuOpen(false);
          }} className="block w-full text-center px-4 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 shadow-sm" data-id="element-220" data-mp="3bxyjxdo4w1ff">
                Book a 30-Min Intake
              </a>
            </div>
          </div>
        </div>}
    </header>;
}